import React, { useState } from 'react';
import { exportDataToExcel } from '../exportDataToExcel'; // The utility function above
import '../CSS/TriggerAlerts.css';
import Sidebar from '../Component/Sidebar';
const TriggerAlerts = () => {
  const [storeName, setStoreName] = useState('All Stores');
  const [date, setDate] = useState('');
  const [reason, setReason] = useState('');
  const [solvedBy, setSolvedBy] = useState('All Employees');
  const [status, setStatus] = useState('All Categories');
  const [videoFilter, setVideoFilter] = useState('');

  // Sample data
  const [alerts] = useState([
    {
      storeName: 'Testor #1',
      date: '2/10/2023 9:12 AM',
      reason: 'Some Reason',
      solvedBy: 'John Doe',
      status: 'Open',
      video: 'Available',
    },
    {
      storeName: 'Testor #2',
      date: '2/10/2023 10:45 AM',
      reason: 'Another Reason',
      solvedBy: 'Jane Smith',
      status: 'Closed',
      video: 'Unavailable',
    },
    // more rows...
  ]);

  // Filter logic (simplified)
  const filteredAlerts = alerts.filter((alert) => {
    const matchesStore =
      storeName === 'All Stores' || alert.storeName === storeName;
    const matchesSolvedBy =
      solvedBy === 'All Employees' || alert.solvedBy === solvedBy;
    const matchesStatus =
      status === 'All Categories' || alert.status === status;
    const matchesVideo =
      videoFilter === '' || alert.video === videoFilter;
    const matchesDate = !date || alert.date.includes(date);
    const matchesReason =
      !reason || alert.reason.toLowerCase().includes(reason.toLowerCase());

    return (
      matchesStore &&
      matchesSolvedBy &&
      matchesStatus &&
      matchesVideo &&
      matchesDate &&
      matchesReason
    );
  });

  // Handler for exporting to Excel
  const handleExportExcel = () => {
    // You might want to export the *filtered* data, not the entire dataset
    exportDataToExcel(filteredAlerts, 'TriggerAlerts');
  };

  return (
    <div className='index-box'>
        <Sidebar />
    <div className="trigger-alerts-container">
      <h2 className="trigger-alerts-title">Trigger Alerts</h2>

      <div className="trigger-alerts-filter-bar">
        {/* Filter Name */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="storeName">Filter Name:</label>
          <select
            id="storeName"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
          >
            <option>All Stores</option>
            <option>Testor #1</option>
            <option>Testor #2</option>
          </select>
        </div>

        {/* Date */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="date">Date:</label>
          <input
            type="date"
            id="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        {/* Reason */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="reason">Reason:</label>
          <input
            type="text"
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason"
          />
        </div>

        {/* Solved By */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="solvedBy">Solved By:</label>
          <select
            id="solvedBy"
            value={solvedBy}
            onChange={(e) => setSolvedBy(e.target.value)}
          >
            <option>All Employees</option>
            <option>John Doe</option>
            <option>Jane Smith</option>
          </select>
        </div>

        {/* Status */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="status">Status:</label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option>All Categories</option>
            <option>Open</option>
            <option>Closed</option>
          </select>
        </div>

        {/* Video */}
        <div className="trigger-alerts-filter-group">
          <label htmlFor="videoFilter">Video:</label>
          <select
            id="videoFilter"
            value={videoFilter}
            onChange={(e) => setVideoFilter(e.target.value)}
          >
            <option value="">All</option>
            <option value="Available">Available</option>
            <option value="Unavailable">Unavailable</option>
          </select>
        </div>

        {/* Export Button */}
        <div className="trigger-alerts-export-button">
          <button onClick={handleExportExcel} className="export-button">
            Export Excel
          </button>
        </div>
      </div>

      <table className="trigger-alerts-table">
        <thead>
          <tr>
            <th>Store Name</th>
            <th>Date</th>
            <th>Reason</th>
            <th>Solved By</th>
            <th>Status</th>
            <th>Video</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredAlerts.map((alert, index) => (
            <tr key={index}>
              <td>{alert.storeName}</td>
              <td>{alert.date}</td>
              <td>{alert.reason}</td>
              <td>{alert.solvedBy}</td>
              <td>{alert.status}</td>
              <td>{alert.video}</td>
              <td>
                <button className="trigger-alerts-edit-button">Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default TriggerAlerts;
